import isMobile from 'ismobilejs/cjs';

export default ({ req }, inject) => {
	const userAgent = process.server && req ? req.headers['user-agent'] : navigator.userAgent;

	const isMobileInstance = isMobile(userAgent || 'unknown');

	inject('isMobile', isMobileInstance);
};
